import { useCallback } from "react"

import { useMMKVBoolean } from "react-native-mmkv"

const AI_PROCESSING_NOTICE_ACCEPTANCE_KEY = "user.setup.hasAcceptedAiProcessingNotice"

export function useAiProcessingNoticeAcceptance(userId: string | undefined) {
  const key = userId
    ? `${AI_PROCESSING_NOTICE_ACCEPTANCE_KEY}.${userId}`
    : AI_PROCESSING_NOTICE_ACCEPTANCE_KEY
  const [hasAccepted, setHasAccepted] = useMMKVBoolean(key)

  const accept = useCallback(() => {
    setHasAccepted(true)
  }, [setHasAccepted])

  const decline = useCallback(() => {
    setHasAccepted(false)
  }, [setHasAccepted])

  return {
    hasAcceptedAiProcessingNotice: hasAccepted ?? false,
    acceptAiProcessingNotice: accept,
    declineAiProcessingNotice: decline,
  }
}
